import { apiSlice } from "./apiSlice";
import { USERS_URL, AUTH_URL, DOCTOR_AUTH_URL, EMPLOYEE_AUTH_URL, PASSWORD_URL, PATIENT_AUTH_URL } from "../../constants/urls";

export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /** Doktor / asistan e-posta-şifre girişi */
    login: builder.mutation({
      query: (data) => ({
        url: `${DOCTOR_AUTH_URL}/Login`,
        method: "POST",
        body: data,
      }),
    }),
    /** Çalışan (admin) panel girişi — süper login */
    employeeLogin: builder.mutation({
      query: (data) => ({
        url: `${EMPLOYEE_AUTH_URL}/Login`,
        method: "POST",
        body: data,
      }),
    }),
    loginWithFirebase: builder.mutation({
      query: (data) => ({
        url: `${DOCTOR_AUTH_URL}/LoginWithFirebase`,
        method: "POST",
        body: data,
      }),
    }),
    registerWithGoogle: builder.mutation({
      query: (data) => ({
        url: `${DOCTOR_AUTH_URL}/RegisterWithFirebase`,
        method: "POST",
        body: data
      })
    }),
    registerWithFirebase: builder.mutation({
      query: (data) => ({
        url: `${DOCTOR_AUTH_URL}/RegisterWithFirebase`,
        method: "POST",
        body: data
      })
    }),
    loginWithGoole: builder.mutation({
      query: (data) => ({
        url: `${DOCTOR_AUTH_URL}/LoginWithFirebase`,
        method: "POST",
        body: data
      })
    }),
    getProfile: builder.mutation({
      query: () => ({
        url: `${USERS_URL}`,
        method: "GET",
      }),
    }),
    refreshToken: builder.query({
      query: () => ({
        url: `${AUTH_URL}/refreshToken`,
        method: "GET",
      }),
    }),
    logout: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/logout`,
        method: 'POST',
        body: data
      })
    }),
    sendCodeToMail: builder.mutation({
      query: (email) => ({
        url: `${AUTH_URL}/SendCodeToMail/${email}`,
        method: "GET",
      }),
    }),
    sendCodeToGsm: builder.mutation({
      query: (gsmNo) => ({
        url: `${AUTH_URL}/SendCodeToGsm/${gsmNo}`,
        method: "GET",
      }),
    }),
    /** @deprecated Doctor/Patient için `setPassword` kullanın */
    updatePassword: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/UpdatePassword`,
        method: "POST",
        body: data,
      }),
    }),
    checkAccount: builder.mutation({
      query: (data) => ({
        url: `${DOCTOR_AUTH_URL}/CheckAccount`,
        method: "POST",
        body: data,
      }),
    }),
    /** Asistan oturumdayken şifre belirleme (DB hash akışı) */
    resetPasswordUser: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/ResetPassword`,
        method: "POST",
        body: data,
      }),
    }),
    /** Hasta + doktor — şifremi unuttum (public) */
    requestPasswordReset: builder.mutation({
      query: (data) => ({
        url: `${PASSWORD_URL}/RequestReset`,
        method: "POST",
        body: data,
      }),
    }),
    /** Hasta + doktor — mail linkinden şifre onayı (public) */
    confirmPasswordReset: builder.mutation({
      query: (data) => ({
        url: `${PASSWORD_URL}/ConfirmReset`,
        method: "POST",
        body: data,
      }),
    }),
    /** Hasta + doktor — oturumdayken şifre oluştur / değiştir (Bearer JWT) */
    setPassword: builder.mutation({
      query: (data) => ({
        url: `${PASSWORD_URL}/Set`,
        method: "POST",
        body: data,
      }),
    }),
    requestEmployeePasswordReset: builder.mutation({
      query: (data) => ({
        url: `${EMPLOYEE_AUTH_URL}/RequestPasswordReset`,
        method: "POST",
        body: data,
      }),
    }),
    confirmEmployeePasswordReset: builder.mutation({
      query: (data) => ({
        url: `${EMPLOYEE_AUTH_URL}/ConfirmPasswordReset`,
        method: "POST",
        body: data,
      }),
    }),
    requestAssistantPasswordReset: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/RequestAssistantPasswordReset`,
        method: "POST",
        body: data,
      }),
    }),
    confirmAssistantPasswordReset: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/ConfirmAssistantPasswordReset`,
        method: "POST",
        body: data,
      }),
    }),
    /** Hasta — mail linkinden e-posta doğrulama (public, JWT gerekmez) */
    confirmEmailVerification: builder.mutation({
      query: (data) => ({
        url: `${PATIENT_AUTH_URL}/ConfirmEmailVerification`,
        method: "POST",
        body: data,
      }),
    }),
    /** Hasta — e-posta doğrulama mailini yeniden gönder (public) */
    requestEmailVerification: builder.mutation({
      query: (data) => ({
        url: `${PATIENT_AUTH_URL}/RequestEmailVerification`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginWithFirebaseMutation,
  useLoginMutation,
  useEmployeeLoginMutation,
  useGetProfileMutation,
  useRefreshTokenQuery,
  useLazyRefreshTokenQuery,
  useRegisterWithGoogleMutation,
  useLoginWithGooleMutation,
  useRegisterWithFirebaseMutation,
  useLogoutMutation,
  useSendCodeToMailMutation,
  useSendCodeToGsmMutation,
  useUpdatePasswordMutation,
  useCheckAccountMutation,
  useResetPasswordUserMutation,
  useRequestPasswordResetMutation,
  useConfirmPasswordResetMutation,
  useSetPasswordMutation,
  useRequestEmployeePasswordResetMutation,
  useConfirmEmployeePasswordResetMutation,
  useRequestAssistantPasswordResetMutation,
  useConfirmAssistantPasswordResetMutation,
  useConfirmEmailVerificationMutation,
  useRequestEmailVerificationMutation,
} = usersApiSlice;
